import { Link } from "react-router-dom";
import styles from "./Aplicacoes.module.css";
import { useEffect, useState } from "react";
import load from "../../../Images/loading.gif";
import axios from "axios";

function Aplicacoes() {
    const [user, setUser] = useState(null);
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get("https://eclipsebots.com/api/profile", { withCredentials: true })
            .then((res) => {
                setUser(res.data);
            })
            .catch(() => {
                setUser(null);
            });
    }, []);

    useEffect(() => {
        const fetchApps = async () => {
            try {
                const response = await fetch(`https://eclipsebots.com/api/aplicacoes/${user.id}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch planos");
                }

                const data = await response.json();

                setApps(data);
            } catch (error) {
                console.error("Erro ao buscar apps:", error);
                setApps([]);
            } finally {
                setLoading(false);
            }
        }
        fetchApps();
    }, [user]);


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    return (
        <div className={styles.aplicacoes}>
            <div className={styles.title}>Serviços</div>
            {apps.length === 0 ? (
                <div className={styles.noData}>
                    Não possui nenhum serviço ativo de momento, adquira um em <Link to={"/planos"}>Planos</Link>
                </div>
            ) : (
                <div className={styles.apps}>
                    {apps.map((app, index) => {
                        const isFirst = index === 0;
                        const isLast = index === apps.length - 1;

                        return (
                            <Link to={`/dashboard/aplicacoes/${app.serviceId}`}>
                                <div key={app.serviceId} className={`${styles.app} ${isFirst ? styles.first : ""} ${isLast ? styles.last : ""}`}>
                                    <div className={styles.emoji}>
                                        {getEmoji(app.status)}
                                    </div>
                                    <div className={styles.name}>
                                        {app.serviceName}
                                    </div>
                                </div>
                            </Link>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

const getEmoji = (type) => {
    switch (type) {
        case "pending": return "🕒";
        case "disabled": return "🔴";
        case "active": return "🟢";
        default: return "🔔";
    }
};

export default Aplicacoes;